import { connect } from 'react-redux';
import { filterSetFilters } from 'redux/saga/selectors';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { SEARCH } from 'constants/filter-sets';
import { DEFAULT_RESULT_TYPE_LOGGED_IN } from './filters/filters.saga';
import { searchFilterActions } from './filters/filters.helpers';
import { canSelectNextDay } from './filters/DateFilter.helpers';
import { FILTER_NAMES } from './Search.constants';
import { SearchNoResults } from './SearchNoResults';
import { selectActiveLocation } from './SearchBox/SearchBox.reducer';
import {
  clearScheduleFiltersAndSearch,
  clearVenueFiltersAndSearch,
  watchSearchNoResults,
} from './SearchNoResults.saga';

const { setFilterValue } = searchFilterActions;

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const resultType = deepExtract(`${FILTER_NAMES.RESULT_TYPE}.value`, filters, DEFAULT_RESULT_TYPE_LOGGED_IN);
  const selectedDate = deepExtract('date.value', filters);
  const location = selectActiveLocation(state);
  const timezone = location && location.timezone;

  return {
    isNextDaySelectable: canSelectNextDay(timezone, selectedDate),
    resultType,
    selectedDate,
  };
};

export const mapDispatchToProps = {
  clearScheduleFiltersAndSearch,
  clearVenueFiltersAndSearch,
  onSelectDate: value => setFilterValue(FILTER_NAMES.DATE, value),
};

export const SearchNoResultsContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSagas({
    watch: [watchSearchNoResults],
  }),
  withName('SearchNoResultsContainer')
)(SearchNoResults);
